import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-darker border-y border-brand-gray" data-id="element-45">
      <div className="max-w-4xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-47">
          <div className="shrink-0" data-id="element-48">
            <div className="w-32 h-32 md:w-48 md:h-48 bg-brand-orange/10 rounded-full flex items-center justify-center border border-brand-orange/30" data-id="element-49">
              <ShieldAlert className="w-16 h-16 md:w-24 md:h-24 text-brand-orange" data-id="element-50" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-51">
            <h2 className="text-3xl md:text-5xl font-bold text-white uppercase mb-6" data-id="element-52">
              Garantía Alpha de 30 Días
            </h2>
            <p className="text-lg md:text-xl text-brand-muted leading-relaxed" data-id="element-53">
              Si en 30 días no sientes que este es el mejor manual de
              rendimiento que has leído, o simplemente no te gusta el formato,
              envíanos un email. Te devolvemos tus $6.36 de inmediato y te
              quedas con el protocolo.{' '}
              <strong className="text-white" data-id="element-54">
                No hay preguntas, ni letras chiquitas. El riesgo es 0.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}